import { render, staticRenderFns } from "./PersistConfigAlertaView.vue?vue&type=template&id=731d5e4f&"
import script from "./PersistConfigAlertaView.vue?vue&type=script&lang=ts&"
export * from "./PersistConfigAlertaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports